import {
  GuestGroup,
  isGuestDetailsRegisteredStatus,
  isGuestFullyRegisteredStatus,
} from '@chekin/core';

export function deriveGuestGroupStats(
  data: GuestGroup | undefined,
  isIVEnabled: boolean,
) {
  const hasNoGuests = data?.added_number_of_guests === 0;
  const areAllGuestsRegistered =
    (data?.known_number_of_guests ?? 0) <= (data?.added_number_of_guests ?? 0);
  const missingGuests = !data
    ? 0
    : data.known_number_of_guests - data.added_number_of_guests;

  const leaderGuest = data?.members?.find(guest => guest?.id === data?.leader_id);
  const members = data?.members ?? [];
  const totalGuests = data?.known_number_of_guests || members.length || 0;
  const totalRegisteredGuests = members.filter(member =>
    isGuestDetailsRegisteredStatus(member.guestapp_status),
  ).length;
  const totalFullyRegisteredGuests = members.filter(member =>
    isGuestFullyRegisteredStatus(member.guestapp_status),
  ).length;
  const totalCompletedGuests = isIVEnabled
    ? totalFullyRegisteredGuests
    : totalRegisteredGuests;
  const totalIncompletedGuests = data
    ? Math.max(totalGuests - totalCompletedGuests, 0)
    : 0;
  const isRegistrationComplete = totalGuests > 0 && totalCompletedGuests >= totalGuests;

  return {
    hasNoGuests,
    isLeaderGuest: hasNoGuests,
    leaderGuest,
    areAllGuestsRegistered,
    missingGuests,
    totalGuests,
    totalRegisteredGuests,
    totalFullyRegisteredGuests,
    totalCompletedGuests,
    totalIncompletedGuests,
    isRegistrationComplete,
  };
}
